import { 
	CHECK_NOTIFICATION,
	CHECK_NOTIFICATION_ERROR,
	CHECK_NOTIFICATION_SUCCESS,
	GET_ALL_NOTIFICATIONS,
	GET_ALL_NOTIFICATIONS_ERROR,
	GET_ALL_NOTIFICATIONS_SUCCESS,
	GET_NOTIFICATIONS, 
	GET_NOTIFICATIONS_ERROR, 
	GET_NOTIFICATIONS_SUCCESS, 
  } from 'redux/constants/Notification';

const initState = {
	loading: false,
	notifications: [],
	count: 0,
	count_unseen: 0,
	message: '',
	all_loading: false,
	all_notifications: [],
	all_count: 0,
	all_message: ''
}

const notification = (state = initState, action) => {
	switch (action.type) {
		case GET_NOTIFICATIONS:
			return {
				...state,
				loading: true
			}
		case GET_NOTIFICATIONS_SUCCESS:
			return {
				...state,
				loading: false,
				notifications: action.data.notifications,
				count: action.data.count,
				count_unseen: action.data.count_unseen
			}
		case GET_NOTIFICATIONS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_ALL_NOTIFICATIONS:
			return {
				...state,
				all_loading: true
			}
		case GET_ALL_NOTIFICATIONS_SUCCESS:
			return {
				...state,
				all_loading: false,
				all_notifications: action.data.notifications,
				all_count: action.data.count,
			}
		case GET_ALL_NOTIFICATIONS_ERROR: 
			return {
				...state,
				all_loading: false,
				all_message: action.message,
			}
		default:
			return state;
	}
}

export default notification